import React from 'react';
import {useAppSelector} from "../DAL/store";
import {getIsAuthenticated} from "../../../../domain/hidden-data-provider";
import {getReturnURL} from "../../../../domain/url-provider";
import DataHelper from "../DAL/data-service";
import MyCouponsItem from "./MyCouponItem";


/**
 * Main MyCoupons App
 */
const MyCouponsApp = () => {

    const coupWrap = useAppSelector((store) => store.coupWrap);
    if(coupWrap.myCouponsList === null || coupWrap.myCouponsList.length === 0)
    {
        return <p className="">You currently have no coupons.</p>;
    }

    const isUserLoggedIn = getIsAuthenticated();
    const gData = DataHelper.GroupAndSortDataList(coupWrap.myCouponsList);
    //console.log('myCouponsList: ',gData);
    return (
        <div className="max-w-full">
            { isUserLoggedIn && <div className="text-xl font-bold">Here are all your current Waves coupons:</div> }
            { !isUserLoggedIn && <a className="blue9-link" href={getReturnURL()} title="">Log in to check if you have personal coupons</a> }
            <ul className="mt-8">
                {
                    gData.map((coup, i) => {
                        return (
                            <MyCouponsItem key={i} item={coup} />
                        );
                    })
                }
            </ul>
        </div>

    )
};

export default  MyCouponsApp;